(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
(function() {
  function updateCountdown() {
    // Target date: December 22, 12pm EST
    const currentYear = new Date().getFullYear();
    let targetYear = currentYear;
    
    // Create target date: Dec 22, 12:00:00
    // We'll create it as if it's in EST, then convert
    // December is always EST (UTC-5)
    const estOffsetMs = -5 * 60 * 60 * 1000; // EST is UTC-5
    
    // Create UTC date representing Dec 22 12pm EST
    // If EST is UTC-5, then 12pm EST = 5pm UTC
    let targetUTC = new Date(Date.UTC(targetYear, 01, 11, 17, 0, 0)); // 17:00 UTC = 12:00 EST
    let targetTimestamp = targetUTC.getTime();
    
    // Get current time in EST
    const now = new Date();
    const nowESTString = now.toLocaleString('en-US', { 
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    
    const nowParts = nowESTString.match(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/);
    if (!nowParts) return;
    
    const nowMonth = parseInt(nowParts[1]);
    const nowDay = parseInt(nowParts[2]);
    const nowYear = parseInt(nowParts[3]);
    const nowHour = parseInt(nowParts[4]);
    const nowMinute = parseInt(nowParts[5]);
    const nowSecond = parseInt(nowParts[6]);
    
    // Check if we're in EDT (March-November) or EST (November-March)
    // For simplicity, December is always EST
    const nowESTOffset = (nowMonth >= 3 && nowMonth <= 10) ? -4 : -5; // EDT is -4, EST is -5
    const nowESTOffsetMs = nowESTOffset * 60 * 60 * 1000;
    const nowUTC = new Date(Date.UTC(nowYear, nowMonth - 1, nowDay, nowHour, nowMinute, nowSecond));
    const nowTimestamp = nowUTC.getTime() - nowESTOffsetMs;
    
    // If target has passed this year, use next year
    if (targetTimestamp <= nowTimestamp) {
      targetYear = currentYear + 1;
      targetUTC = new Date(Date.UTC(targetYear, 11, 22, 17, 0, 0));
      targetTimestamp = targetUTC.getTime();
    }
    
    // Calculate difference
    const difference = targetTimestamp - nowTimestamp;
    
    // Split into tens and units
    function splitDigits(value) {
      const str = value.toString().padStart(2, '0');
      return {
        tens: parseInt(str[0]),
        units: parseInt(str[1])
      };
    }
    
    // Find all countdown timer containers
    const countdownTimers = document.querySelectorAll('.count-down-timer');
    
    // Update each countdown timer independently
    countdownTimers.forEach(function(timerContainer) {
      if (difference <= 0) {
        // Countdown has ended - set all to 0
        timerContainer.querySelectorAll('.count-down-timer__item-value-number').forEach(function(el) {
          el.textContent = '0';
        });
        return;
      }
      
      // Calculate time units
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);
      
      const daysDigits = splitDigits(days);
      const hoursDigits = splitDigits(hours);
      const minutesDigits = splitDigits(minutes);
      const secondsDigits = splitDigits(seconds);
      
      // Update DOM elements within this specific timer container
      const daysTens = timerContainer.querySelector('[data-tens="days"]');
      const daysUnits = timerContainer.querySelector('[data-units="days"]');
      const hoursTens = timerContainer.querySelector('[data-tens="hours"]');
      const hoursUnits = timerContainer.querySelector('[data-units="hours"]');
      const minutesTens = timerContainer.querySelector('[data-tens="minutes"]');
      const minutesUnits = timerContainer.querySelector('[data-units="minutes"]');
      const secondsTens = timerContainer.querySelector('[data-tens="seconds"]');
      const secondsUnits = timerContainer.querySelector('[data-units="seconds"]');
      
      if (daysTens) daysTens.textContent = daysDigits.tens;
      if (daysUnits) daysUnits.textContent = daysDigits.units;
      if (hoursTens) hoursTens.textContent = hoursDigits.tens;
      if (hoursUnits) hoursUnits.textContent = hoursDigits.units;
      if (minutesTens) minutesTens.textContent = minutesDigits.tens;
      if (minutesUnits) minutesUnits.textContent = minutesDigits.units;
      if (secondsTens) secondsTens.textContent = secondsDigits.tens;
      if (secondsUnits) secondsUnits.textContent = secondsDigits.units;
    });
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  } else {
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamonds-video"]) return;
  try {
    
    // $(document).ready(function () {
    //     let playIcon = $(".video-pre-icon #play");
    //     let stopIcon = $(".video-pre-icon #stop");
    //     let labVideo = $("#labVideo");
    //     playIcon.on("click", function () {
    //         labVideo.trigger('play');
    //         stopIcon.show();
    //         $(this).hide();
    //     });
    //     stopIcon.on("click", function () {
    //         labVideo.trigger('pause');
    //         playIcon.show();
    //         $(this).hide();
    //     });
    //     labVideo.on("ended", function () {
    //         labVideo.load();
    //         playIcon.show();
    //         stopIcon.hide();
    //     });
    // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-main-slider"] && !Shopify.designMode) return;
  try {
     
  document.addEventListener('DOMContentLoaded', function () {
    const windowWidth = window.innerWidth;
    if (windowWidth > 1024) {
        const triggers = document.querySelector('.dropdown-btn-wrapper');
        triggers.addEventListener('mouseenter', function () {
        const dropdown = document.querySelector('.dropdown-menu');
        dropdown.style.display = 'block';
        });
        triggers.addEventListener('mouseleave', function () {
        const dropdown = document.querySelector('.dropdown-menu');
        dropdown.style.display = 'none';
        });
    }else{
        const triggers = document.querySelectorAll('.dropdown-trigger');
        triggers.forEach(trigger => {
        trigger.addEventListener('click', function () {
            const dropdown = trigger.nextElementSibling;
            dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';

            document.querySelectorAll('.dropdown-menu').forEach(menu => {
            if (menu !== dropdown) {
                menu.style.display = 'none';
            }
            });
        });
        });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.dropdown')) {
        document.querySelectorAll('.dropdown-menu').forEach(menu => {
          menu.style.display = 'none';
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video"] && !Shopify.designMode) return;
  try {
     
  $(document).ready(function () {
    $(".video_wrapper").on("click", function () {
      $(this).find("video").css({
        'opacity': 1,
        'z-index': 1
      }).trigger('play');
      $(this).find(".video-poster").css("opacity", "0");
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["id-me-select-jewelry"]) return;
  try {
    
    $(".idme-jewelry-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 1.16,
                    slidesToScroll: 1,
                },
            },
        ],
    });

  } catch(e) { console.error(e); }
})();
})();
